import { Component, Input, OnInit } from '@angular/core';
import { EViewType } from 'projects/shared/lib/enum/view-type/view-type.enum';
import { ProductIdentifierDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';


@Component({
    selector: 'app-widget-product-card',
    imports: [],
    templateUrl: './widget-product-card.component.html',
    styleUrls: ['./widget-product-card-base.component.scss']
})
export class WidgetProductCardBaseComponent extends WidgetBaseComponent implements OnInit {
  @Input() public viewType: EViewType | undefined = EViewType.GRID;
  public eViewType: typeof EViewType = EViewType;

  private productNumber: string | undefined;

  public productIdentifier: ProductIdentifierDto | undefined;
  public productListProduct: any = undefined;

  public ngOnInit(): void {
    this.productNumber = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ProductNumber") == 0)?.value;
    this.productIdentifier = new ProductIdentifierDto({
      productNumber: this.productNumber
    });
  }
}
